<template>
  <div class="layout">
    <!-- 固定顶部导航 -->
    <header class="header-fixed">
      <HeaderTop @handleInput="onSearchInput" />
    </header>

    <!-- 可滚动的主要内容区域 -->
    <main class="main-content">
      <div class="content-wrapper">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive" />
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive" />
      </div>

      <!-- 底部 -->
      <Footer />
    </main>
  </div>
</template>

<script>
import HeaderTop from "@/components/HeaderTop/HeaderTop.vue";
import Footer from "@/components/Footer/index.vue";

export default {
  name: "Layout",
  components: {
    HeaderTop,
    Footer,
  },
  methods: {
    // 处理HeaderTop的搜索输入
    onSearchInput(searchValue) {
      // 使用localStorage存储全局搜索状态
      localStorage.setItem("globalSearchValue", searchValue);
      localStorage.setItem("isFromGlobalSearch", "true");

      // 如果当前路由不在allApps页面，则跳转到应用页面
      if (this.$route.path !== "/allApps") {
        this.$router.push({
          path: "/allApps",
        });
      }

      setTimeout(() => {
        this.$bus.$emit("updateHeaderActiveIndex", "1");
        // 通过Event Bus发送搜索事件给所有监听的组件
        this.$bus.$emit("globalSearch", searchValue);
      }, 300);
    },
  },
};
</script>

<style lang="scss" scoped>
.layout {
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.header-fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.main-content {
  flex: 1;
  padding-top: 123px; /* HeaderTop组件的实际高度 */
  overflow-y: auto;
  overflow-x: hidden;
}
</style>